module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-top-stone-path.e10e4cca.png";